import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function AboutMe() {
  return (
    <section id="about" className="about--section">
      <div className="about--section--img">
        <img src="./img/pokemon.jpg" alt="About us" />
      </div>
      <div className=" about--section--box">
        <h1>About us</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem
          officiis sit debitis omnis harum sed veniam quasi dicta accusamus
          recusandae? Voluptatem, reprehenderit alias? Eligendi aperiam tempora
          numquam sint odit optio.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem
          officiis sit debitis omnis harum sed veniam quasi dicta accusamus
          recusandae?
        </p>
        <Button variant="primary" className="mt-3">
          <Link to="/" style={{ color: "white", textDecoration: "none" }}>
            Back to Home
          </Link>
        </Button>
      </div>
    </section>
  );
}
